import {
  beEmailMessageApiCreatePlainText,
  beEmailMessageApiGetMessageDetailsLazy,
  beEmailMessageApiSavePlainText
} from 'Api/beEmailMessageApi'

export const getMessageDetails = async idMessage => {
  const result = await beEmailMessageApiGetMessageDetailsLazy(idMessage)

  if (result) {
    return {
      idMessage: result.Id,
      name: result.Subject,
      plainText: result.PlainText
    }
  }

  return { idMessage: 0, name: '', plainText: '' }
}

export const getPlainText = async idMessage => {
  const result = await beEmailMessageApiCreatePlainText(idMessage)

  if (result) {
    return result.Result
  }

  return ''
}

export const saveMessage = async (idMessage, plainText) => {
  const correctPlainText = plainText.replaceAll(`"`, `\"`)
  const res = await beEmailMessageApiSavePlainText(idMessage, {
    PlainText: correctPlainText
  })

  if (res) {
    return res.Result
  }
  return false
}

export const deletePlainText = async idMessage => {
  const res = await beEmailMessageApiSavePlainText(idMessage, {
    PlainText: ''
  })

  if (res) {
    return res.Result
  }
  return false
}
